export default {
  timeout: {
    staySignedIn: 101593, // Stay signed in
    youHaveBeenIdleForXMinutes: 101592, // You have been idle for {minutes} minutes
    youWillBeLoggedOutInXSeconds: 101594, // You will be logged out in {counter} seconds. Do you want to stay signed in?
  }
}
